/**
 * Authentication service
 * Handles user login, token management, and session persistence
 */

import { setAuthToken, setUserInfo, clearAuthData, UserInfo } from "./storage.service";
import { httpClient } from "./http.service";

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  user: UserInfo;
}

export interface AuthError {
  message: string;
  status?: number;
}



/**
 * Authenticate user with backend API
 * @param credentials Username and password
 * @returns Promise with token and user info
 * @throws AuthError if authentication fails
 */
export async function login(credentials: LoginRequest): Promise<LoginResponse> {
  try {
    const data = await httpClient<LoginResponse>("/auth/login", {
      method: "POST",
      body: JSON.stringify(credentials),
    });

    // Store authentication data
    setAuthToken(data.token);
    setUserInfo(data.user);

    return data;
  } catch (error) {
    console.error("DEBUG: Login Fetch Error:", error);
    if ((error as AuthError).status) {
      throw error;
    }

    // Network or other errors
    throw {
      message: "Erreur de connexion au serveur. Vérifiez votre connexion internet.",
    } as AuthError;
  }
}

/**
 * Logout user and clear authentication data
 */
export function logout(): void {
  clearAuthData();
}
